// apps/admin/src/services/authService.ts
import apiClient, { API_URL } from './apiClient';

export interface UserProfile {
  id: string;
  email: string;
  name: string;
  title?: string;
  company?: string;
  role: string;
  bio?: string;
  avatar_url?: string;
  linkedin?: string;
}

export const authService = {
  async login(email: string, password: string): Promise<void> {
    const formData = new URLSearchParams({ username: email, password });
    const res = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.detail ?? 'Login failed');
    }
    const { access_token } = await res.json();
    apiClient.setToken(access_token);
  },

  async logout(): Promise<void> {
    apiClient.clearToken();
  },

  async getSession(): Promise<{ access_token: string } | null> {
    const token = apiClient.getToken();
    return token ? { access_token: token } : null;
  },

  async getCurrentUser(): Promise<UserProfile | null> {
    try {
      return await apiClient.get<UserProfile>('/users/me');
    } catch {
      return null;
    }
  },
};

export default authService;
